export default __webpack_public_path__ + "2d412b4518d5ab8e088e28eff96590a9.svg";